export default __webpack_public_path__ + "static/media/wMEMO.1a50a889.png";